import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.structured-clone.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "stage-container"
};
const _hoisted_2 = {
  class: "stage-info-container"
};
const _hoisted_3 = {
  class: "stage-name"
};
const _hoisted_4 = {
  key: 0,
  class: "map-container"
};
const _hoisted_5 = {
  key: 2,
  class: "common-dice-container"
};
const _hoisted_6 = {
  key: 3,
  class: "operate-container"
};
const _hoisted_7 = {
  key: 4,
  class: "operate-container"
};
const _hoisted_8 = {
  key: 5,
  class: "operate-container"
};
const _hoisted_9 = {
  key: 6,
  class: "operate-container"
};
const _hoisted_10 = {
  key: 10,
  class: "roles-info-container"
};
const _hoisted_11 = {
  key: 11,
  class: "roles-info-container"
};
import { computed, onUnmounted, onMounted, ref, nextTick } from 'vue'; // import {useWindowSize} from '@vueuse/core'

import { ElIcon, ElMessage, ElRow } from 'element-plus';
import { FullScreen, Grid, RefreshLeft, MapLocation, Notebook, Operation, PieChart, SwitchButton, Timer, UserFilled, Lock, Unlock } from '@element-plus/icons-vue';
import { getPerformanceDesc, inApostleType, inLoggedType, isUserType } from '@/tools/utils';
import { changeSliderWidth, pageStyle, resetSliderWidth, sliderWidth } from "@/theme/sliderStyle";
import { request } from '@/manager/net_manager';
import store from '@/store';
import router from '@/router';
import { socketService } from '@/manager/socket_manager';
import dbManager from '@/tools/indexedDB';
import StageRolesBar from '@/components/Stage/StageRolesBar.vue';
import ChatContainer from '@/components/Stage/ChatContainer.vue';
import QuickDicePicker from "@/components/Stage/QuickDicePicker.vue";
import RoleStatusCard from "@/components/Stage/RoleStatusCard.vue";
import StageRolesManager from "@/components/Stage/StageRolesManager.vue";
import MaskerLayer from "@/components/Basic/MaskerLayer.vue";
import StatusUpdater from "@/components/Stage/StatusUpdater.vue";
import MapContainer from "@/components/Stage/MapContainer.vue";
import StagePocket from "@/components/Stage/StagePocket.vue";
import StageScheduleManager from "@/components/Stage/StageScheduleManager.vue";
import DraggableContainer from "@/components/Stage/DraggableContainer.vue"; // constants

export default {
  __name: 'StagePage',

  setup(__props) {
    let timeUpdateTimer = null; // const {width, } = useWindowSize()

    const defaultModulesInfo = {
      'locked': false,
      'fullScreen': false,
      'chat-container': {
        key: 'chat-container',
        x: 60,
        y: 68,
        width: 420,
        height: 600,
        minWidth: 360,
        minHeight: 420,
        translucent: false
      },
      'quick-dice-picker': {
        key: 'quick-dice-picker',
        x: 492,
        y: 68,
        width: 360,
        height: 540,
        minWidth: 300,
        minHeight: 300,
        translucent: false,
        open: false
      },
      'role-status-card': {
        key: 'role-status-card',
        x: 492,
        y: 68,
        width: 320,
        height: 400,
        minWidth: 160,
        minHeight: 320,
        translucent: true,
        open: true
      }
    }; // refs

    const message = ref(null);
    const socketConnected = ref(false);
    const stageId = ref(null);
    const performanceStatus = ref(null);
    const modulesInfo = ref(structuredClone(defaultModulesInfo));
    const modulesLocked = ref(false);
    const onlineActor = ref([]);
    const onlineAudience = ref([]);
    const apostle = ref(null);
    const ferryman = ref(null);
    const chatRef = ref(null);
    const mapRef = ref(null);
    const statusChanging = ref(false);
    const roleStatusMode = ref(true);
    const showPocket = ref(false);
    const scheduleMode = ref(false); // computed

    const userType = computed(() => store.state.user ? parseInt(store.state.user.user_type) : 4);
    const stage = computed(() => store.state.stage ?? null);
    const ticketRole = computed(() => store.state.stage_role ?? null);
    const isActor = computed(() => {
      if (!ticketRole.value || !isUserType(userType.value)) return false;
      return ticketRole.value.position === 'actor';
    });
    const isApostle = computed(() => {
      if (!ticketRole.value || !inApostleType(userType.value)) return false;
      return ticketRole.value.position === 'apostle';
    });
    const isAudience = computed(() => {
      if (!ticketRole.value || !isUserType(userType.value)) return false;
      return ticketRole.value.position === 'audience';
    }); // const stageData = computed(() => {
    //   if (!ticketRole.value) return null
    //   return store.state.stage_data
    // })

    const mapData = computed(() => store.state.stage_data?.map_data ?? null);
    const rolesData = computed(() => store.state.stage_data?.roles_data ?? null);
    const scheduleData = computed(() => store.state.stage_data?.schedule_data ?? null);
    const ticketRoleData = computed(() => {
      if (!isActor.value || !rolesData.value) return null;
      const roleData = rolesData.value[ticketRole.value.id];
      if (!roleData) return null;
      return roleData;
    });
    const ticketRolePossibility = computed(() => ticketRoleData.value?.possibility ?? null); // const hasAudience = computed(() => {
    //   if (!stage.value) return false
    //   return stage.value.audience_capacity !== 0
    // })

    const actor = computed(() => {
      if (!stage.value || !stage.value.performance.cast) return [];
      return stage.value.performance.cast;
    });
    const audience = computed(() => {
      if (!stage.value || !stage.value.performance.audience) return [];
      return stage.value.performance.audience;
    }); // functions

    const getData = () => {
      if (!stageId.value) return;
      if (message.value) message.value.close();
      request('stage/get/', {
        'stage_id': stageId.value
      }, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          store.commit('update_stage', response.data);
          const anchor = response.data.performance.anchor;
          apostle.value = {
            'id': 'apostle',
            'nickname': anchor.name,
            'avatar': anchor.avatar
          };
          ferryman.value = { ...response.data.ferryman,
            'id': 'ferryman'
          };
          performanceStatus.value = stage.value.performance.status;

          if (!socketService.socket) {
            socketConnected.value = false;
            attemptWSConnect();
          } else {
            socketConnected.value = true;
            socketService.send({
              'type': 'get_roles',
              'text': ''
            });
            socketService.send({
              'type': 'recent_messages',
              'text': ''
            });
            socketService.send({
              'type': 'get_stage_data',
              'text': ''
            });
            setupModulesInfo();
          }
        } else {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          stageLogout();
        }
      });
    };

    const stageLogout = () => {
      store.commit('update_stage', null);
      store.commit('update_stage_role', null);
      store.commit('delete_stage_data');
      store.dispatch('stage_ws_disconnect');
      resetSliderWidth();
      router.replace('/lounge');
    };

    const loadStageData = message => {
      let data = null;

      try {
        data = JSON.parse(message);
      } catch (e) {
        data = message;
      } // console.log('loadStageData', JSON.stringify(data))


      for (const key in data) {
        store.commit('update_stage_data', {
          key: key,
          value: data[key]
        });

        if (key === 'roles_data' && ticketRole.value) {
          for (const roleId in data[key]) {
            if (roleId === ticketRole.value.id) {
              store.commit('update_role_info', {
                role_id: roleId,
                key: 'stage_role_data',
                value: data[key][roleId]
              });
            }
          }
        }
      }
    };

    const operateEvent = async event => {
      switch (event) {
        case 'positionReset':
          modulesInfo.value = Object.keys(defaultModulesInfo).reduce((acc, key) => {
            const moduleData = defaultModulesInfo[key];

            if (key === 'fullScreen') {
              acc[key] = modulesInfo.value[key];
            } else if (key === 'locked') {
              acc[key] = false;
            } else {
              acc[key] = { ...moduleData,
                ...{
                  open: modulesInfo.value[key].open,
                  translucent: modulesInfo.value[key].translucent
                }
              };
            }

            return acc;
          }, {});
          saveModulesInfo();
          break;

        case 'positionLock':
          modulesLocked.value = !modulesLocked.value;
          modulesInfo.value['locked'] = modulesLocked.value;
          saveModulesInfo();
          break;

        case 'fullScreen':
          changeSliderWidth();
          modulesInfo.value['fullScreen'] = sliderWidth.value === 0;
          saveModulesInfo();
          break;

        case 'roleStatus':
          {
            const buffer = modulesInfo.value['role-status-card'];
            modulesInfo.value['role-status-card'] = { ...buffer,
              open: !buffer.open
            };
            saveModulesInfo();
          }
          break;

        case 'quickDice':
          {
            const buffer = modulesInfo.value['quick-dice-picker'];
            modulesInfo.value['quick-dice-picker'] = { ...buffer,
              open: !buffer.open
            };
            saveModulesInfo();
          }
          break;

        default:
          break;
      }
    };

    const stageUpdated = () => {
      socketService.send({
        'type': 'get_stage_data',
        'text': ''
      });
      getData();
    };

    const attemptWSConnect = () => {
      if (!stageId.value) return;
      if (message.value) message.value.close();
      const parameters = {
        'stage_id': stageId.value
      };
      request('stage/access_token/get/', parameters, 'POST').then(response => {
        // console.log(JSON.stringify(response))
        if (response.code === 0) {
          store.commit('update_stage_role', response.data.role_info);
          store.dispatch('stage_ws_connect', response.data.access_token);
          setupModulesInfo();
        } else {
          message.value = ElMessage.error({
            message: response.msg,
            duration: 1500
          });
          stageLogout();
        }
      });
    };

    const attemptWSReconnect = () => {
      // console.log('attemptWSReconnect')
      if (!stageId.value) return;
      if (apostle.value) apostle.value.is_online = false;
      onlineActor.value = [];
      onlineAudience.value = [];
      chatRef.value?.clearMessages();
      chatRef.value?.forceUpdate();
      attemptWSConnect();
    };

    const setupListeners = () => {
      // console.log('StagePage 初始化ws监测')
      socketService.on('connected', () => {
        socketConnected.value = true;
      });
      socketService.on('disconnected', () => {
        socketConnected.value = false; // attemptWSConnect()
      });
      socketService.on('error', () => {
        socketConnected.value = false; // attemptWSConnect()
      });
      socketService.on('roles', rolesUpdate);
      socketService.on('chats', receivedChatMessage); // socketService.on('role_data', loadRoleData)

      socketService.on('stage_data', loadStageData);
      socketService.on('stage_update', stageUpdated);
    };

    const setupModulesInfo = () => {
      if (!ticketRole.value || !inLoggedType(userType.value)) return;
      const storeKey = `stage_modules:${userType.value}_${ticketRole.value.id}`;
      let storeModules = localStorage.getItem(storeKey);

      if (storeModules && typeof storeModules === 'string') {
        try {
          storeModules = JSON.parse(storeModules);
          if (storeModules) modulesInfo.value = storeModules;
        } catch (e) {
          console.error(e);
          localStorage.removeItem(storeKey);
        }
      } else {
        localStorage.setItem(storeKey, JSON.stringify(modulesInfo.value));
      }

      if (sliderWidth.value === 0 !== modulesInfo.value['fullScreen']) {
        changeSliderWidth();
      }

      if (modulesLocked.value !== modulesInfo.value['locked']) {
        modulesLocked.value = !modulesLocked.value;
      }
    };

    const moduleDataChanged = moduleData => {
      if (!moduleData) return;
      modulesInfo.value[moduleData['key']] = moduleData;
      saveModulesInfo();
    };

    const saveModulesInfo = () => {
      // console.log('saveModulesInfo', JSON.stringify(modulesInfo.value))
      if (!ticketRole.value || !inLoggedType(userType.value)) return;
      const storeKey = `stage_modules:${userType.value}_${ticketRole.value.id}`;
      localStorage.setItem(storeKey, JSON.stringify(modulesInfo.value));
    };

    const rolesUpdate = message => {
      let data = null;

      try {
        data = JSON.parse(message);
      } catch (e) {
        data = message;
      } // console.log('roles_update 获取data', typeof data, JSON.stringify(data))


      if (data instanceof Array) {
        onlineActor.value = data.filter(item => item['is_online'] === 1 && item['position'] === 'actor').map(item => item['id']);
        onlineAudience.value = data.filter(item => item['is_online'] === 1 && item['position'] === 'audience').map(item => item['id']);

        if (apostle.value) {
          apostle.value.is_online = data.filter(item => item['is_online'] === 1 && item['position'] === 'apostle').length === 1;
        }
      } else {
        const roleId = data['id'];
        const position = data['position'];
        const isOnline = data['is_online'] === 1;

        if (ticketRole.value && roleId === ticketRole.value.id) {
          // console.log('不做自身的舞台状态提醒')
          return;
        } // console.log(`单体检测身份 ${position} 在线状态${isOnline}`)


        let eventContent = '';

        if (position === 'actor') {
          const index = onlineActor.value.findIndex(item => item === roleId); // console.log(`index ${index}`)

          if (!isOnline && index !== -1) {
            onlineActor.value.splice(index, 1);
          } else if (isOnline && index === -1) {
            onlineActor.value.push(roleId);
          }

          eventContent = `角色 ${data['nickname']} ${isOnline ? '加入' : '离开'}了当前舞台`;
        } else if (position === 'audience') {
          // console.log(`index ${index}`)
          const index = onlineAudience.value.findIndex(item => item === roleId);

          if (!isOnline && index !== -1) {
            onlineAudience.value.splice(index, 1);
          } else if (isOnline && index === -1) {
            onlineAudience.value.push(roleId);
          }

          eventContent = `观众 ${data['nickname']} ${isOnline ? '加入' : '离开'}了当前舞台`;
        } else if (position === 'apostle') {
          if (apostle.value) apostle.value.is_online = isOnline;
          eventContent = `链接者 ${data['nickname']} ${isOnline ? '加入' : '离开'}了当前舞台`;
        } else if (position === 'illusion') {
          eventContent = `蜃 ${isOnline ? '加入' : '离开'}了当前舞台`;
        }

        addRoleUpdatedMessage({
          'id': data['message_id'],
          'timestamp': data['timestamp'],
          'stage_id': stageId.value,
          'role_id': roleId,
          'type': 'rolesUpdate',
          'content': eventContent
        });
      } // console.log('onlineActor', JSON.stringify(onlineActor.value))
      // console.log('onlineAudience', JSON.stringify(onlineAudience.value))

    };

    const addRoleUpdatedMessage = async (message, retryCount = 0) => {
      if (!chatRef.value) return;

      if (!chatRef.value.isInitializing) {
        if (retryCount >= 3) {
          console.error(`已达到最大重试次数，放弃发送消息`);
          return;
        }

        const delay = 100 * Math.pow(2, retryCount);
        await new Promise(resolve => setTimeout(resolve, delay));
        return addRoleUpdatedMessage(message, retryCount + 1);
      }

      chatRef.value.addMessage(message);
      chatRef.value.scrollToBottom();
    };

    const receivedChatMessage = message => {
      let data = null;

      try {
        data = JSON.parse(message);
      } catch (e) {
        data = message;
      }

      if (!chatRef.value) return; // console.log(`receivedChatMessage data = ${JSON.stringify(data)}`)
      // console.log(`receivedChatMessage isarray = ${data instanceof Array}`)

      if (data instanceof Array) {
        dbManager.bulkAdd('messages', data, true);
        chatRef.value?.fetchMessageWithIndexedDB();
        chatRef.value?.forceUpdate();
        chatRef.value?.scrollToBottom(true);
      } else {
        if (message.type !== 'event') {
          dbManager.add('messages', data);
        } // console.log(`message = ${JSON.stringify(data)}`)


        chatRef.value.addMessage(data);

        if (message.role_id === ticketRole.value.id) {
          chatRef.value.addSelfMessage(data);
        }

        chatRef.value?.updateTimeTag();
        chatRef.value?.scrollToBottom();
      }
    };

    const sendMessage = content => {
      if (!chatRef.value || !ticketRole.value) return;
      if (message.value) message.value.close();

      if (!socketService.socket) {
        message.value = ElMessage.error({
          message: '未连接到舞台',
          duration: 1500
        });
        return;
      }

      socketService.send({
        'type': 'chat_message',
        'text': {
          'type': 'chat',
          'content': content
        }
      });
      chatRef.value.scrollToBottom(true);
    };

    const sendPropMessage = content => {
      if (!chatRef.value || !ticketRole.value) return;
      if (message.value) message.value.close();

      if (!socketService.socket) {
        message.value = ElMessage.error({
          message: '未连接到舞台',
          duration: 1500
        });
        return;
      }

      socketService.send({
        'type': 'show_prop',
        'text': {
          'content': content
        }
      });
      chatRef.value.scrollToBottom(true);
    };

    const startTimestampUpdater = async () => {
      timeUpdateTimer = setInterval(() => {
        // console.log('timeUpdateTimer run')
        chatRef.value?.updateTimeTag();
      }, 30 * 1000);
      await nextTick();

      if (chatRef.value) {
        chatRef.value.updateTimeTag();
      }
    };

    const resetRole = (roleId, mode = 'prev') => {
      if (inApostleType(userType.value)) {
        socketService.send({
          'type': 'reset_role_data',
          'text': {
            'role_id': roleId,
            'mode': mode
          }
        });
      }
    };

    const reloadRoleData = roleId => {
      if (inApostleType(userType.value)) {
        socketService.send({
          'type': 'reload_role_data',
          'text': {
            'role_id': roleId
          }
        });
      }
    };

    const updateMapData = mapData => {
      // console.log(JSON.stringify(mapData))
      if (inApostleType(userType.value)) {
        socketService.send({
          'type': 'map_data_update',
          'text': mapData
        });
      }
    };

    const deleteMapData = mapId => {
      if (inApostleType(userType.value)) {
        socketService.send({
          'type': 'map_data_delete',
          'text': mapId
        });
      }
    };

    const updateRolesData = payload => {
      socketService.send({
        'type': 'role_status_update',
        'text': payload
      });
      statusChanging.value = false;
    };

    const updateScheduleData = payload => {
      socketService.send({
        'type': 'schedule_data_update',
        'text': payload
      }); // scheduleMode.value = false
    };

    const openStagePocket = () => {
      if (isActor.value) showPocket.value = true;
    };

    const openStatusUpdater = () => {
      if (!isApostle.value || !actor.value || actor.value.length === 0) return;
      statusChanging.value = true;
    };

    const openScheduleUpdater = () => {
      if (!actor.value || actor.value.length === 0) return;
      scheduleMode.value = true;
    };

    const showRoleCard = roleId => {}; // const getStageDesc = (stageItem) => {
    //   return `${stageItem.stage_name} / ${getPerformanceDesc(stageItem.performance.status)}`
    // }
    // lifecycle


    onMounted(() => {
      setupListeners();
      startTimestampUpdater();

      if (stage.value) {
        stageId.value = stage.value.stage_id;
        getData();
      }

      if (socketService.socket) {
        socketConnected.value = true;
      }
    });
    onUnmounted(() => {
      socketService.removeAllListeners();
      resetSliderWidth();

      if (timeUpdateTimer) {
        clearInterval(timeUpdateTimer);
      } // console.log('unmounted', stage.value)


      if (!stage.value) {
        if (socketService.socket) {
          // console.log('stage_ws_disconnect')
          store.dispatch('stage_ws_disconnect');
        }

        dbManager.close();
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "page-container",
        style: _normalizeStyle(_unref(pageStyle))
      }, [stage.value && ticketRole.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("text", _hoisted_3, _toDisplayString(`${stage.value.stage_name} / 「${stage.value.performance.drama.name}」 / ${_unref(getPerformanceDesc)(stage.value.performance.status)}`), 1), _createVNode(StageRolesBar, {
        roles: actor.value,
        capacity: stage.value.actor_capacity,
        apostle: apostle.value,
        "online-roles": onlineActor.value,
        "item-diameter": 32
      }, null, 8, ["roles", "capacity", "apostle", "online-roles"]), socketConnected.value ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        class: "exit-stage",
        onClick: stageLogout
      }, {
        default: _withCtx(() => [_cache[17] || (_cache[17] = _createElementVNode("div", {
          class: "v-divider"
        }, null, -1)), _createVNode(_unref(ElIcon), {
          size: 16
        }, {
          default: _withCtx(() => [_createVNode(_unref(SwitchButton))]),
          _: 1
        }), _cache[18] || (_cache[18] = _createElementVNode("text", {
          style: {
            "margin-left": "6px"
          }
        }, [_createElementVNode("b", null, "断开连接")], -1))]),
        _: 1
      })) : (_openBlock(), _createBlock(_unref(ElRow), {
        key: 1,
        class: "exit-stage reconnect-stage",
        onClick: attemptWSReconnect
      }, {
        default: _withCtx(() => [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "v-divider"
        }, null, -1)), _createVNode(_unref(ElIcon), {
          size: 16
        }, {
          default: _withCtx(() => [_createVNode(_unref(RefreshLeft))]),
          _: 1
        }), _cache[20] || (_cache[20] = _createElementVNode("text", {
          style: {
            "margin-left": "6px"
          }
        }, [_createElementVNode("b", null, "重建连接")], -1))]),
        _: 1
      }))]), performanceStatus.value === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(MapContainer, {
        ref_key: "mapRef",
        ref: mapRef,
        "map-data": mapData.value ?? {},
        role: ticketRole.value,
        actor: actor.value,
        onUpdateMapData: updateMapData,
        onDeleteMapData: deleteMapData
      }, null, 8, ["map-data", "role", "actor"])])) : _createCommentVNode("", true), [0, 2].includes(performanceStatus.value) ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["common-chat-container", isActor.value ? 'actor' : ''])
      }, [ticketRole.value ? (_openBlock(), _createBlock(ChatContainer, {
        key: 0,
        ref_key: "chatRef",
        ref: chatRef,
        "stage-id": stageId.value,
        "current-role": ticketRole.value,
        "role-array": [...actor.value, ...audience.value, apostle.value, ferryman.value],
        onSpeak: sendMessage
      }, null, 8, ["stage-id", "current-role", "role-array"])) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true), [0, 2].includes(performanceStatus.value) && isActor.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(QuickDicePicker, {
        data: ticketRolePossibility.value,
        translucent: modulesInfo.value['quick-dice-picker']?.translucent,
        onDiceEvent: sendMessage
      }, null, 8, ["data", "translucent"])])) : _createCommentVNode("", true), performanceStatus.value === 1 && isActor.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_unref(ElIcon), {
        class: _normalizeClass(modulesInfo.value['role-status-card'].open ? 'active' : ''),
        onClick: _cache[0] || (_cache[0] = $event => operateEvent('roleStatus'))
      }, {
        default: _withCtx(() => [_createVNode(_unref(UserFilled))]),
        _: 1
      }, 8, ["class"]), _createVNode(_unref(ElIcon), {
        class: "active",
        onClick: _cache[1] || (_cache[1] = $event => operateEvent('positionReset'))
      }, {
        default: _withCtx(() => [_createVNode(_unref(RefreshLeft))]),
        _: 1
      }), _createVNode(_unref(ElIcon), {
        class: _normalizeClass(modulesLocked.value ? 'active' : ''),
        onClick: _cache[2] || (_cache[2] = $event => operateEvent('positionLock'))
      }, {
        default: _withCtx(() => [modulesLocked.value ? (_openBlock(), _createBlock(_unref(Lock), {
          key: 0
        })) : (_openBlock(), _createBlock(_unref(Unlock), {
          key: 1
        }))]),
        _: 1
      }, 8, ["class"]), _createVNode(_unref(ElIcon), {
        class: _normalizeClass(modulesInfo.value['quick-dice-picker'].open ? 'active' : ''),
        onClick: _cache[3] || (_cache[3] = $event => operateEvent('quickDice'))
      }, {
        default: _withCtx(() => [_createVNode(_unref(Operation))]),
        _: 1
      }, 8, ["class"]), _createVNode(_unref(ElIcon), {
        class: _normalizeClass(_unref(sliderWidth) === 0 ? 'active' : ''),
        onClick: _cache[4] || (_cache[4] = $event => operateEvent('fullScreen'))
      }, {
        default: _withCtx(() => [_createVNode(_unref(FullScreen))]),
        _: 1
      }, 8, ["class"]), _createVNode(_unref(ElIcon), {
        onClick: openStagePocket
      }, {
        default: _withCtx(() => [_createVNode(_unref(Grid))]),
        _: 1
      }), _createVNode(_unref(ElIcon), {
        onClick: openScheduleUpdater
      }, {
        default: _withCtx(() => [_createVNode(_unref(Timer))]),
        _: 1
      })])) : _createCommentVNode("", true), performanceStatus.value === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_unref(ElIcon), {
        class: _normalizeClass(_unref(sliderWidth) === 0 ? 'active' : ''),
        onClick: _cache[5] || (_cache[5] = $event => operateEvent('fullScreen'))
      }, {
        default: _withCtx(() => [_createVNode(_unref(FullScreen))]),
        _: 1
      }, 8, ["class"])])) : performanceStatus.value === 1 && isApostle.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_unref(ElIcon), {
        class: _normalizeClass(roleStatusMode.value ? 'active' : ''),
        onClick: _cache[6] || (_cache[6] = $event => operateEvent('roleStatus'))
      }, {
        default: _withCtx(() => [_createVNode(_unref(UserFilled))]),
        _: 1
      }, 8, ["class"]), _createVNode(_unref(ElIcon), {
        class: "active",
        onClick: _cache[7] || (_cache[7] = $event => operateEvent('positionReset'))
      }, {
        default: _withCtx(() => [_createVNode(_unref(RefreshLeft))]),
        _: 1
      }), _createVNode(_unref(ElIcon), {
        class: _normalizeClass(modulesLocked.value ? 'active' : ''),
        onClick: _cache[8] || (_cache[8] = $event => operateEvent('positionLock'))
      }, {
        default: _withCtx(() => [modulesLocked.value ? (_openBlock(), _createBlock(_unref(Lock), {
          key: 0
        })) : (_openBlock(), _createBlock(_unref(Unlock), {
          key: 1
        }))]),
        _: 1
      }, 8, ["class"]), _createVNode(_unref(ElIcon), {
        class: _normalizeClass(_unref(sliderWidth) === 0 ? 'active' : ''),
        onClick: _cache[9] || (_cache[9] = $event => operateEvent('fullScreen'))
      }, {
        default: _withCtx(() => [_createVNode(_unref(FullScreen))]),
        _: 1
      }, 8, ["class"]), _createVNode(_unref(ElIcon), {
        onClick: openStatusUpdater
      }, {
        default: _withCtx(() => [_createVNode(_unref(PieChart))]),
        _: 1
      }), _createVNode(_unref(ElIcon), {
        onClick: mapRef.value?.mapGenerator
      }, {
        default: _withCtx(() => [_createVNode(_unref(MapLocation))]),
        _: 1
      }, 8, ["onClick"]), _createVNode(_unref(ElIcon), {
        onClick: openScheduleUpdater
      }, {
        default: _withCtx(() => [_createVNode(_unref(Timer))]),
        _: 1
      }), _createVNode(_unref(ElIcon), null, {
        default: _withCtx(() => [_createVNode(_unref(Notebook))]),
        _: 1
      })])) : _createCommentVNode("", true), performanceStatus.value === 1 && isAudience.value ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_unref(ElIcon), {
        class: _normalizeClass(roleStatusMode.value ? 'active' : ''),
        onClick: _cache[10] || (_cache[10] = $event => operateEvent('roleStatus'))
      }, {
        default: _withCtx(() => [_createVNode(_unref(UserFilled))]),
        _: 1
      }, 8, ["class"]), _createVNode(_unref(ElIcon), {
        class: "active",
        onClick: _cache[11] || (_cache[11] = $event => operateEvent('positionReset'))
      }, {
        default: _withCtx(() => [_createVNode(_unref(RefreshLeft))]),
        _: 1
      }), _createVNode(_unref(ElIcon), {
        class: _normalizeClass(modulesLocked.value ? 'active' : ''),
        onClick: _cache[12] || (_cache[12] = $event => operateEvent('positionLock'))
      }, {
        default: _withCtx(() => [modulesLocked.value ? (_openBlock(), _createBlock(_unref(Lock), {
          key: 0
        })) : (_openBlock(), _createBlock(_unref(Unlock), {
          key: 1
        }))]),
        _: 1
      }, 8, ["class"]), _createVNode(_unref(ElIcon), {
        class: _normalizeClass(_unref(sliderWidth) === 0 ? 'active' : ''),
        onClick: _cache[13] || (_cache[13] = $event => operateEvent('fullScreen'))
      }, {
        default: _withCtx(() => [_createVNode(_unref(FullScreen))]),
        _: 1
      }, 8, ["class"]), _createVNode(_unref(ElIcon), {
        onClick: openScheduleUpdater
      }, {
        default: _withCtx(() => [_createVNode(_unref(Timer))]),
        _: 1
      })])) : _createCommentVNode("", true), performanceStatus.value === 1 && ticketRole.value ? (_openBlock(), _createBlock(DraggableContainer, {
        key: 7,
        data: modulesInfo.value['chat-container'],
        locked: modulesLocked.value,
        onUpdate: moduleDataChanged
      }, {
        default: _withCtx(() => [_createVNode(ChatContainer, {
          ref_key: "chatRef",
          ref: chatRef,
          "stage-id": stageId.value,
          "current-role": ticketRole.value,
          "role-array": [...actor.value, ...audience.value, apostle.value, ferryman.value],
          translucent: modulesInfo.value['chat-container']?.translucent ?? false,
          onSpeak: sendMessage
        }, null, 8, ["stage-id", "current-role", "role-array", "translucent"])]),
        _: 1
      }, 8, ["data", "locked"])) : _createCommentVNode("", true), performanceStatus.value === 1 && isActor.value && modulesInfo.value['role-status-card'].open && ticketRoleData.value ? (_openBlock(), _createBlock(DraggableContainer, {
        key: 8,
        data: modulesInfo.value['role-status-card'],
        locked: modulesLocked.value,
        onUpdate: moduleDataChanged
      }, {
        default: _withCtx(() => [_createVNode(RoleStatusCard, {
          data: ticketRoleData.value,
          "role-info": ticketRole.value,
          "schedule-data": scheduleData.value,
          translucent: modulesInfo.value['role-status-card']?.translucent ?? false
        }, null, 8, ["data", "role-info", "schedule-data", "translucent"])]),
        _: 1
      }, 8, ["data", "locked"])) : _createCommentVNode("", true), [0, 1].includes(performanceStatus.value) && isActor.value && modulesInfo.value['quick-dice-picker'].open ? (_openBlock(), _createBlock(DraggableContainer, {
        key: 9,
        data: modulesInfo.value['quick-dice-picker'],
        locked: modulesLocked.value,
        onUpdate: moduleDataChanged
      }, {
        default: _withCtx(() => [_createVNode(QuickDicePicker, {
          data: ticketRolePossibility.value,
          translucent: modulesInfo.value['quick-dice-picker']?.translucent,
          onDiceEvent: sendMessage
        }, null, 8, ["data", "translucent"])]),
        _: 1
      }, 8, ["data", "locked"])) : _createCommentVNode("", true), performanceStatus.value === 1 && isApostle.value && roleStatusMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_10, [rolesData.value ? (_openBlock(), _createBlock(StageRolesManager, {
        key: 0,
        data: rolesData.value,
        actor: actor.value,
        "online-actor": onlineActor.value,
        onClickRole: showRoleCard
      }, null, 8, ["data", "actor", "online-actor"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), performanceStatus.value === 1 && isAudience.value && roleStatusMode.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [rolesData.value ? (_openBlock(), _createBlock(StageRolesManager, {
        key: 0,
        data: rolesData.value,
        actor: actor.value,
        "online-actor": onlineActor.value
      }, null, 8, ["data", "actor", "online-actor"])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), showPocket.value ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 1,
        onClose: _cache[14] || (_cache[14] = $event => showPocket.value = false)
      }, {
        default: _withCtx(() => [_createVNode(StagePocket, {
          "stage-id": stageId.value,
          "role-id": ticketRole.value.id,
          "role-name": ticketRole.value.nickname,
          onShowPropEvent: sendPropMessage
        }, null, 8, ["stage-id", "role-id", "role-name"])]),
        _: 1
      })) : _createCommentVNode("", true), statusChanging.value ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 2,
        onClose: _cache[15] || (_cache[15] = $event => statusChanging.value = false)
      }, {
        default: _withCtx(() => [_createVNode(StatusUpdater, {
          data: rolesData.value,
          actor: actor.value,
          onResetRole: resetRole,
          onSubmitUpdates: updateRolesData,
          onReloadRole: reloadRoleData
        }, null, 8, ["data", "actor"])]),
        _: 1
      })) : _createCommentVNode("", true), scheduleMode.value ? (_openBlock(), _createBlock(MaskerLayer, {
        key: 3,
        onClose: _cache[16] || (_cache[16] = $event => scheduleMode.value = false)
      }, {
        default: _withCtx(() => [_createVNode(StageScheduleManager, {
          data: scheduleData.value,
          actor: actor.value,
          onSubmitUpdates: updateScheduleData
        }, null, 8, ["data", "actor"])]),
        _: 1
      })) : _createCommentVNode("", true)], 4);
    };
  }

};